export default __webpack_public_path__ + "static/media/bg_2.99b0db1f.png";